import { render, staticRenderFns } from "./PreCustomerProfile.vue?vue&type=template&id=33a4fcf3&scoped=true&"
import script from "./PreCustomerProfile.vue?vue&type=script&lang=js&"
export * from "./PreCustomerProfile.vue?vue&type=script&lang=js&"
import style0 from "./PreCustomerProfile.vue?vue&type=style&index=0&id=33a4fcf3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a4fcf3",
  null
  
)

export default component.exports